import { render, staticRenderFns } from "./avisos.vue?vue&type=template&id=97d3dfb4&scoped=true&"
import script from "./avisos.vue?vue&type=script&lang=js&"
export * from "./avisos.vue?vue&type=script&lang=js&"
import style0 from "./avisos.vue?vue&type=style&index=0&id=97d3dfb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d3dfb4",
  null
  
)

export default component.exports